import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';
import { Observable, of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';


@Pipe({
  standalone: false,
  name: 'statusEventTranslate'
})

export class StatusEventTranslatePipe implements PipeTransform {
  eventMaps: any;
  constructor(private store: Store<fromStore.State>, private translateService: TranslateService) {
    this.store.select(fromStore.getEventsMapsState).pipe(first(i => i.Loaded && !i.Loading)).subscribe(res => {
      this.eventMaps = Object.values(res.entities).reduce((acc, item) => {
        acc[`EventNumber_${item.num}`] = item.desc;
        return acc;
      }, {});
    });
  }
  transform(value: any, args?: any): Observable<string> {
    if (value === '' || typeof value === 'undefined' || value === null) {
      return of('');
    }

    return this.translateService.stream(value).pipe(
      // 使用 RxJS 的 map 運算子來處理每個發出的值
      map(translatedValue => {
        // 檢查翻譯是否失敗 (ngx-translate 預設會返回 key)
        if (translatedValue === value) {
          // 翻譯失敗，觸發後備邏輯
          const event_enum_mapping_value = this.eventMaps[value];

          // 如果在後備對應表中找到，就返回後備值，否則返回原始 key
          return event_enum_mapping_value || value;
        }
        return translatedValue;
      }),
      catchError(err => {
        return of(value); // 出錯時返回原始 key
      })
    );
  }

}
